export default __webpack_public_path__ + "static/media/background.fec1caf8.png";